import { deleteRequest, get,post} from "services/BaseClient/Client"
import endPoints from "./EndPoints"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import { CreateUrlFilter } from "helpers/CreateURLFilter";




export const getAdvertListFilter= async (filter:any): Promise<DataResponse<any>> => {
  const query = CreateUrlFilter(filter)
    const url = `${endPoints.getAdvertList}?${query}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

export const saveFilterProperties = (data:any)=>{
  const url = `${endPoints.saveFilter}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
}
export const deleteAdvert = (data:any)=>{
  const url = `${endPoints.deleteAdvertList}/${data.id}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data,config);
}
export const removeAdFromPublication = (data:any)=>{
  const url = `${endPoints.removeFromPublication}/${data.id}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data,config);
}
export const publishAdvert = (data:any)=>{
  const url = `${endPoints.publishAdvert}/${data.id}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
}
  